// extracted by mini-css-extract-plugin
export default {"root":"styles-module__root--YA2kb","buttonContainer":"styles-module__buttonContainer--XykG5"};